
import React, { useEffect, useState } from 'react';
import { Line, Bar, Scatter } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const Component = () => {
  const salesData = [
    { month: 'Jan 2024', new_vehicle_sales: 220, used_vehicle_sales: 140, inventory_level: 520, appointment_set_rate: 40.0, appointment_close_rate: 33.0 },
    { month: 'Feb 2024', new_vehicle_sales: 210, used_vehicle_sales: 145, inventory_level: 510, appointment_set_rate: 38.0, appointment_close_rate: 35.0 },
    { month: 'Mar 2024', new_vehicle_sales: 250, used_vehicle_sales: 155, inventory_level: 550, appointment_set_rate: 45.0, appointment_close_rate: 38.0 },
    { month: 'Apr 2024', new_vehicle_sales: 230, used_vehicle_sales: 160, inventory_level: 530, appointment_set_rate: 42.0, appointment_close_rate: 40.0 },
    { month: 'May 2024', new_vehicle_sales: 240, used_vehicle_sales: 165, inventory_level: 550, appointment_set_rate: 41.0, appointment_close_rate: 42.0 },
    { month: 'Jun 2024', new_vehicle_sales: 260, used_vehicle_sales: 175, inventory_level: 570, appointment_set_rate: 46.0, appointment_close_rate: 45.0 },
    { month: 'Jul 2024', new_vehicle_sales: 280, used_vehicle_sales: 185, inventory_level: 600, appointment_set_rate: 48.0, appointment_close_rate: 47.0 },
    { month: 'Aug 2024', new_vehicle_sales: 270, used_vehicle_sales: 190, inventory_level: 590, appointment_set_rate: 47.0, appointment_close_rate: 48.0 },
    { month: 'Sep 2024', new_vehicle_sales: 290, used_vehicle_sales: 200, inventory_level: 610, appointment_set_rate: 50.0, appointment_close_rate: 50.0 },
    { month: 'Oct 2024', new_vehicle_sales: 310, used_vehicle_sales: 215, inventory_level: 630, appointment_set_rate: 55.0, appointment_close_rate: 52.0 },
    { month: 'Nov 2024', new_vehicle_sales: 330, used_vehicle_sales: 225, inventory_level: 650, appointment_set_rate: 60.0, appointment_close_rate: 55.0 },
    { month: 'Dec 2024', new_vehicle_sales: 200, used_vehicle_sales: 150, inventory_level: 500, appointment_set_rate: 35.0, appointment_close_rate: 30.0 }
  ];

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const months = salesData.map(item => item.month);
    const newVehicleSales = salesData.map(item => item.new_vehicle_sales);
    const usedVehicleSales = salesData.map(item => item.used_vehicle_sales);
    const inventoryLevels = salesData.map(item => item.inventory_level);
    const appointmentSetRate = salesData.map(item => item.appointment_set_rate);
    const appointmentCloseRate = salesData.map(item => item.appointment_close_rate);

    setChartData({
      labels: months,
      datasets: [
        {
          label: 'New Vehicle Sales',
          data: newVehicleSales,
          backgroundColor: 'rgba(75, 192, 192, 0.7)',
          yAxisID: 'y-sales',
          stack: 'sales',
        },
        {
          label: 'Used Vehicle Sales',
          data: usedVehicleSales,
          backgroundColor: 'rgba(153, 102, 255, 0.7)',
          yAxisID: 'y-sales',
          stack: 'sales',
        },
        {
          label: 'Inventory Levels (New Vehicles)',
          data: inventoryLevels,
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 2,
          fill: false,
          yAxisID: 'y-inventory',
        },
        {
          label: 'Appointment Set Rate (%)',
          data: appointmentSetRate,
          borderColor: 'rgba(255, 159, 64, 1)',
          backgroundColor: 'rgba(255, 159, 64, 0.2)',
          fill: true,
          yAxisID: 'y-appointments',
          tension: 0.1,
        },
        {
          label: 'Appointment Close Rate (%)',
          data: appointmentCloseRate,
          pointBackgroundColor: 'rgba(255, 99, 132, 1)',
          pointRadius: 5,
          showLine: false,
          yAxisID: 'y-appointments',
          type: 'scatter',
        },
      ],
    });
  }, []);

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        display: true,
        position: 'top',
        labels: {
          usePointStyle: true,
        },
      },
    },
    scales: {
      x: {
        type: 'category',
        labels: chartData ? chartData.labels : [],
      },
      y: {
        id: 'y-sales',
        position: 'left',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Vehicle Sales',
        },
      },
      'y-inventory': {
        id: 'y-inventory',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Inventory Levels (New Vehicles)',
        },
      },
      'y-appointments': {
        id: 'y-appointments',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Appointment Rates (%)',
        },
      },
    },
  };

  return (
    <div>
      {chartData && (
        <div className='container'>
          <h3>Bar Graph</h3>
          <Bar data={chartData} options={options} />
          <h3>Line Graph</h3>
          <Line data={chartData} options={options} />
          <h3>Scatter Graph</h3>
          <Scatter data={chartData} options={options} />
        </div>
      )}
    </div>
  );
};

export default Component;

